import React, { useEffect, useState } from 'react'
import { Avatar as MuiAvatar, CircularProgress } from '@material-ui/core'
import { storageRef } from '../index'
import { Box } from '@mui/material'

const Avatar = ({
  conferenceId,
  imageProps,
  imageName,
  variant,
  path,
  height = 150,
  width = 150
}) => {
  const [image, setImage] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (imageName) {
      downloadImage()
    }
    return () => setImage(null)
  }, [imageName])

  const downloadImage = async () => {
    try {
      if (imageName) {
        setLoading(true)
        const imageUrl = await storageRef
          .child(`${conferenceId}/${path}/${imageName}`)
          .getDownloadURL()
        setImage(imageUrl)
      }
      setLoading(false)
    } catch (err) {
      setLoading(false)
      // do nothing
    }
  }

  return (
    <>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: '0.25rem' }}>
          <CircularProgress size={32} />
        </Box>
      ) : (
        <MuiAvatar
          variant={variant}
          style={{
            border: '1.25px solid #c2c2c2',
            height: height,
            width: width,
            margin: 0
          }}
          imgProps={imageProps}
          src={image}
        />
      )}
    </>
  )
}

export default Avatar
